const bannerSlider = document.querySelector("#mainCarousel");
const bannerSliderControls = $("#banner-thumbnails-controls");
let isPlayActive = true;

const updateIsPlayActive = (e) => {
  e.preventDefault();
  e.stopPropagation();

  if (isPlayActive) {
    bannerSlider.swiper.autoplay.stop();
    bannerSliderControls.find("i").addClass("fa-play").removeClass("fa-pause");
    bannerSliderControls
      .find("button")
      .attr("aria-label", "Odtwórz")
      .attr("aria-pressed", "true");
    isPlayActive = false;
  } else {
    bannerSlider.swiper.autoplay.start();
    bannerSliderControls.find("i").removeClass("fa-play").addClass("fa-pause");
    bannerSliderControls
      .find("button")
      .attr("aria-label", "Zatrzymaj")
      .attr("aria-pressed", "false");
    isPlayActive = true;
  }
};

const bind = function () {
  bannerSliderControls.on("click", updateIsPlayActive);

  $(bannerSlider).on("mouseenter", function () {
    if (isPlayActive) {
      bannerSliderControls
        .find("i")
        .addClass("fa-play")
        .removeClass("fa-pause");
    }
  });

  $(bannerSlider).on("mouseleave", function () {
    if (isPlayActive) {
      bannerSliderControls
        .find("i")
        .removeClass("fa-play")
        .addClass("fa-pause");
    }
  });
};

export { bind };
